import { type Product, createReviewStatsMap } from '@skin-seoul/service';

/**
 * Product data processing utilities for grid components
 * Handles data transformation and processing separate from UI logic
 */

/**
 * Process raw product data from API response
 * Handles cases where data might be undefined or empty
 */
export const processProductsData = (data?: { products?: Product[] }): Product[] => {
  const productList = data?.products?.length ? data.products : [];
  return productList;
};

/**
 * Create review statistics map from review data
 * Re-exports the service utility for consistency
 */
export const createProductReviewStatsMap = createReviewStatsMap;

/**
 * Extract product IDs for review statistics query
 * Joins product IDs into comma-separated string for API call
 */
export const extractProductIdsForReviews = (products: Product[]): string => {
  return products.map((product) => product.productId).join(',');
};

/**
 * Check if products array is empty and log appropriate message
 */
export const isProductsEmpty = (products: Product[]): boolean => {
  return products.length === 0;
};

/**
 * Notify product count change
 * Handles the callback for updating parent component with count
 */
export const notifyProductCountChange = (
  data?: { total?: number },
  onProductCountChange?: (count: number) => void,
): void => {
  if (onProductCountChange && data?.total !== undefined) {
    onProductCountChange(data.total);
  }
};
